import head from 'lodash/head';

import type { ReportEntity } from 'core/entities/report/report-entity';
import { isDateLabel } from 'core/services/date-service/relative-date-service';

export const selectStarredReportDates = (entities: ReportEntity[]) => {
    const primaryEntity = head(entities);
    const startDate = primaryEntity?.filters?.start_date;
    const endDate = primaryEntity?.filters?.end_date;
    const isSameRelativeDate = entities.every(
        (entity) =>
            !!entity.filters.date_label &&
            isDateLabel(entity.filters.date_label) &&
            entity.filters.date_label === entities[0].filters.date_label,
    );
    const dateLabel = isSameRelativeDate ? primaryEntity?.filters?.date_label : undefined;

    const isSameDay = entities.every((entity) => {
        return entity.filters.start_date === startDate && entity.filters.end_date === endDate;
    });

    return {
        isSameDay,
        startDate,
        endDate,
        dateLabel,
    };
};
